import React 
// {useState, useEffect} 
from "react";
import Section from "./Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "./SectionHeader";
import Row from "react-bootstrap/Row";
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Col from "react-bootstrap/Col";
import { useAuth } from "./../util/auth.js";
import  { useWindowScrollPosition } from "./../util/router.js";
import  { useLocalStorage } from "./../util/db.js";
import firebase from '../util/firebase.js';
import "./DashboardSection.scss";
import SmallCard from './SmallCard'
import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import BookmarkCoffee from "./BookmarkCoffee";
import StarRating from "./StarRating";

function DashboardSection(props) {
  const auth = useAuth();
  //save previously selected tab to local storage
  const [tabKey, setTabKey] = useLocalStorage('tabKey', 'tabkey');
  // const [ratedCoffees, setRatedCoffees] = useState([]);
  // const [savedCoffees, setSavedCoffees] = useState([]);  
  // const [loading, setLoading] = useState(true);
  
  // React firebase hooks helps to avoid useEffect
  const uid = auth.user.id;
  const ratedCoffeeQuery = firebase.firestore().collectionGroup('ratings').where('uid', '==', uid).orderBy('createdTime', 'desc')
  const [ratedCoffees] = useCollectionDataOnce(ratedCoffeeQuery);

  const bookmarkCoffeeQuery = firebase.firestore().collectionGroup('saved').where('uid', '==', uid).orderBy('createdTime', 'desc')
  const [bookmarkedCoffees, loadingBookmarkedCoffees] = useCollectionDataOnce(bookmarkCoffeeQuery);
  useWindowScrollPosition('MyAwesomeComponent_ScrollY', (!loadingBookmarkedCoffees)); 


  // const getRatedCoffees = () => {
  //   const uid = auth.user.id;
  //   firebase.firestore().collectionGroup('ratings')
  //   .where('uid', '==', uid)
  //   .orderBy('createdTime', 'desc')
  //   .get().then((item) => {
  //     const items = item.docs.map((doc) => doc.data());
  //     setRatedCoffees(items);
  //     setLoading(false);
  //     console.log("getRatedCoffees firestore pull has run in dashboard")
  //   });
  // }

  // const getSavedCoffees = () => {
  //   const uid = auth.user.id;
  //   firebase.firestore().collectionGroup('saved')
  //   .where('uid', '==', uid)
  //   .orderBy('createdTime', 'desc')
  //   .get().then((item) => {
  //     const items = item.docs.map((doc) => doc.data());
  //     setSavedCoffees(items);
  //     console.log("getSavedCoffees firestore pull has run in dashboard")
  //   });
  // }

  // useEffect(() => {
  //   getSavedCoffees();
  //   getRatedCoffees();
  //   // eslint-disable-next-line
  // }, []);

  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={1}
          spaced={true}
          className="text-center"
        />

          <Tabs  
            className="d-flex justify-content-center align-items-center" 
            activeKey={tabKey}
            onSelect={(k) => setTabKey(k)}
            id="rated-saved-coffees"
            justify
            >

            <Tab eventKey="saved" title="Bookmarked">
              <Row className="justify-content-center">
                {bookmarkedCoffees && bookmarkedCoffees.map(coffee =>
                  <Col
                  xs={10}
                  sm={6}
                  md={4}
                  lg={3}
                  className="py-2 px-2 d-flex align-items-stretch"
                  key={coffee.coffeeId}
                  >
                    <SmallCard 
                      coffee={coffee} 
                      bookmark={<BookmarkCoffee coffee={coffee} />}
                      rating={<StarRating coffee={coffee} />} />
                  </Col>
                )}
              </Row> 
            </Tab>

            <Tab eventKey="rated" title="Rated">
              <Row className="justify-content-center">
                {ratedCoffees && ratedCoffees.map(coffee =>
                  <Col
                  xs={10}
                  sm={6}
                  md={4}
                  lg={3}
                  className="py-2 px-2 d-flex align-items-stretch"
                  key={coffee.coffeeId}
                >
                    <SmallCard 
                      coffee={coffee}
                      bookmark={<BookmarkCoffee coffee={coffee} />}
                      rating={<StarRating coffee={coffee} />} />
                  </Col>
                )}
              </Row> 
            </Tab>

          </Tabs>


        

      </Container>
    </Section>
  );
}

export default DashboardSection;

// {/* <Row> 
          
// <Col>
//   <Button
//       onClick={() => setOpenRatedCoffees(!openRatedCoffees)}
//       aria-controls="example-collapse-text"
//       aria-expanded={openRatedCoffees}
//       variant="outline-success"
//       className="mb-4 align-content-center"
//     >
//     Rated Coffees
//   </Button>
//   <Collapse in={openRatedCoffees}>
//     <div>
//     {ratedCoffees.map(coffee => <SmallCard key={coffee.coffeeId} coffee={coffee} />)}
//     </div>
//   </Collapse>
//   </Col>

//   <Col>
//   <Button
//       onClick={() => setOpenSavedCoffees(!openSavedCoffees)}
//       aria-controls="example-collapse-text"
//       aria-expanded={openSavedCoffees}
//       variant="outline-success"
//       className="mb-4 align-items-center"
//     >
//     Saved Coffees
//   </Button>
//   <Collapse in={openSavedCoffees}>
//     <div>
//     {ratedCoffees.map(coffee => <SmallCard key={coffee.coffeeId} coffee={coffee} />)}
//     </div>
//   </Collapse>
//   </Col>
//     </Row> */}


// {/* <div
// className="mt-5 mx-auto text-center"
// style={{
//   maxWidth: "460px",
// }}
// >
// <ListGroup className="mt-2">

//   <ListGroup.Item>
//     Logged in as <strong>{auth.user.email}</strong>
//   </ListGroup.Item>
 
//   <ListGroup.Item>
//     <Link to="/settings/general">Account settings</Link>
//   </ListGroup.Item>
  
// </ListGroup>
// </div> */}